import { RadioButton, RadioButtonChangeEvent } from "primereact/radiobutton";
import {
  useMonacoThemeVariant,
  MONACO_THEME_VARIANTS,
  type MonacoThemeVariant,
} from "../../../../theme";

export function CodeEditorThemeMenuItem() {
  const { variant, setVariant } = useMonacoThemeVariant();

  return (
    <div style={{ padding: "0.75rem 1rem" }}>
      <div style={{ fontSize: "0.875rem", fontWeight: "600", marginBottom: "0.5rem" }}>
        Code Editor Theme
      </div>
      <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
        {MONACO_THEME_VARIANTS.map(opt => {
          const inputId = `monaco-theme-${opt.value}`;
          return (
            <div key={opt.value} style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
              <RadioButton
                inputId={inputId}
                name="monaco-theme"
                value={opt.value}
                onChange={(e: RadioButtonChangeEvent) => setVariant(e.value as MonacoThemeVariant)}
                checked={variant === opt.value}
              />
              <label htmlFor={inputId} style={{ cursor: "pointer", fontSize: "0.875rem" }}>
                {opt.label}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
}
